const searchableList = (): void => {
  const searchList = (value: string): void => {
    const sections = document.querySelectorAll('[data-list]');

    sections.forEach((list) => {
      const listItems = list.getElementsByTagName('li');
      const filter = value.toUpperCase();
      let itemsVisibleInSection = false;

      for (let i = 0; i < listItems.length; i++) {
        const heading = listItems[i].querySelector<HTMLElement>(
          '.list-item__heading'
        );
        const headingText = heading.textContent || heading.innerText;
        if (headingText.toUpperCase().indexOf(filter) > -1) {
          listItems[i].style.display = '';
          itemsVisibleInSection = true;
        } else {
          listItems[i].style.display = 'none';
        }
      }

      const wrapper = list.closest('.searchable-list__wrapper');
      if (wrapper) {
        const sectionHeading = wrapper.querySelector('h6');
        if (sectionHeading) {
          sectionHeading.style.display = itemsVisibleInSection ? '' : 'none';
        }
      }

      const letter = wrapper ? wrapper.querySelector('h6').id : '';
      const link = document.querySelector(
        `.searchable-list__filters__link[href="#${letter}"]`
      );
      if (link) {
        link.classList[itemsVisibleInSection ? 'remove' : 'add']('hidden');
      }
    });
  };

  const searchListInputs = document.querySelectorAll<HTMLInputElement>(
    '[data-search-list-input]'
  );

  searchListInputs.forEach((input) => {
    input.addEventListener('keyup', () => {
      const value: string = input.value;
      searchList(value);
    });
  });

  const searchableListItems = document.querySelectorAll(
    '.searchable-list__list li'
  );
  searchableListItems.forEach((item) => {
    if (window.location.hash) {
      const location = window.location.hash.replace('#', '');
      const id = item.getAttribute('data-item-id');
      if (location == id) {
        item.classList.toggle('show-content');
      }
    }

    item.addEventListener('click', () => {
      const openItems = document.querySelectorAll(
        '.searchable-list__list li.show-content'
      );
      openItems.forEach((item) => {
        item.classList.remove('show-content');
      });

      item.classList.toggle('show-content');
    });
  });

  document
    .querySelectorAll('.searchable-list__filters__link')
    .forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
};

export default searchableList;
